import { Modal } from "@components";
import { useNavigate } from "react-router-dom";
import { styled, Link as MuiLink } from "@mui/material";
import { theme as OldTheme } from "../../../config";
import { onContactUsClick } from "@utils/index";
import { failedUpdateRequestWsp } from "@constants/index";

const Link = styled(MuiLink)({
  textAlign: "center",
  fontSize: "16px",
  fontWeight: "500",
  lineHeight: "23px",
  letterSpacing: "0.5px",
  color: OldTheme.pallete.text.link,
  cursor: "pointer",
});
interface Props {
  isOpen: boolean;
}

export function UpdateRequestUnknownErrorModal({ isOpen }: Props) {
  const navigate = useNavigate();

  return (
    <Modal
      title="Error al actualizar la solicitud"
      content={
        <>
          Por favor, intenta nuevamente. Si el error persiste,{" "}
          <Link onClick={() => onContactUsClick(failedUpdateRequestWsp)}>
            contáctanos
          </Link>{" "}
          para ayudarte.
        </>
      }
      isOpen={isOpen}
      buttonProps={{
        buttonText: "Volver a inicio",
        onClick: () => {
          navigate("/app/solicitudes");
        },
      }}
    />
  );
}
